import { instance } from "apis/interceptor";

type ResponseType<T> = {
  success: boolean;
  message?: string;
  statusCode?: number;
  data?: T;
};

//INFO: (new) Visitors 방문자 체크인/체크아웃 기록 활성화 여부 조회
export const getWorkspacesEntryLogging = async (): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.get("/workspaces/visitors/entry-logging");
    return { success: true, data: res.data.isEntryLoggingEnabled };
  } catch (error: any) {
    return { success: false, message: "오류가 발생했습니다. 다시 시도해 주세요." };
  }
};